module.exports = __webpack_public_path__ + "img/729.a956196d.gif";